import { LocalStorageService } from './../../../../../core/services/local-storage.service';
import { environment } from './../../../../../../environment/environment';
import { EsnAppeloffreService } from './../../../../../core/services/esn-appeloffre/esn-appeloffre.service';
import { ChangeDetectorRef,Component, ElementRef, TemplateRef } from '@angular/core';
import { AbstractControl,FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ISort,headerColumns4 } from './../../../../../core/models/call-offer';
import { ICandidat } from './../../../../../core/models/candidat';
import {
  EmptyCV,
  obligationSelect,
  serverError,
} from './../../../../../core/models/messages';
import { EsnCandidatService } from './../../../../../core/services/esn-candidat/esn-candidat.service';
import { SalarieService } from './../../../../../core/services/salarie-service/salarie.service';
import { SortDataService } from './../../../../../core/services/sortdata';
import { Country, State } from 'country-state-city';
import * as saveAs from 'file-saver';
import * as JSZip from 'jszip';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { DatePipe } from '@angular/common';
import { EsnJobOfferService } from '@core/services/esn-job-offer-service/esn-job-offer.service';
import { EsnConsultantService } from '@core/services/esn-consultant/esn-consultant.service';
import { PageEvent } from '@angular/material/paginator';
import {
  linkedInRegExp,
  patternEmail,
  patternNumbersOnly,
  patternfirstName,
  patternfirstNamechiffre,
} from './../../../../../core/models/pattern';
import Swal from 'sweetalert2';

enum CompanyType {
  ESN = 'ESN',
  WGU = 'WGU'
}

@Component({
  selector: 'app-candidatureoffreemploi',
  templateUrl: './candidatureoffreemploi.component.html',
  styleUrls: ['./candidatureoffreemploi.component.css'],
})
export class CandidatureoffreemploiComponent {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  minEndDate: Date | null = null; 
  maxStartDate: Date |null = null;
  listmanager: {
    uuid: string; id: number; full_name: string, first_name: string, last_name: string 
    }[] = [];
  listclient: { id: number; name: string }[] = [];
  showResetButtons: boolean = true;
  iscv:boolean=false
  cvName: any;
  company_name: any;
  isexistemail = false;
  isButtonDisabled: boolean = false;
  candidat_id: any;
  file: any = '';
  errorMessageprofil: string = '';
  isvalid: boolean = false;
  client: any[] = [];
  clientList : any[] = [];
  listconsultant: any;
  clientId2_name:any;
  fileError: string = '';
  fileExtention: string = '';
  fileName: string = '';
  pageSize = 5;
  pageSizeOptions = [5, 10, 20];
  freeSearch: boolean = false;
  selectedconsultant: any;
  errorMessage: string = '';
  compt = [
     { id: 1, name: 'Immédiate' },
    { id: 2, name: '2 mois' },
    { id: 3, name: '3 mois' },
    { id: 4, name: '4 mois' },
    { id: 5, name: '5 mois' },
  ];

  contrat = [
    { id: 1, name: 'Alternance' },
    { id: 2, name: 'Autres type de contrat' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
    
  ];
  poste = [
    { id: 1, name: 'A distance' },
    { id: 2, name: 'Hybride' },
    { id: 3, name: 'Sur site' },
  ];
  disponibilite = [
     { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];
  isCollapsed = true;
  companyTypeEnum = CompanyType;
  redirectionCandidateName: any;
  isNotifRedirection: boolean = false;
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  formconsultant: FormGroup = this.createconsultantForm();
  stateList: any = [];
  countries: any = [];
  loadSpinnerTable: boolean = false;
  loadSpinner: boolean = false;
  idclientConnected: any;
  itemsPerPage: number = 5;
  currentPage: number = 0;
  btnSearchactive : boolean = false;
  currentSortDirection: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  totalCandidateItems!: number;
  listcandidats: any;
  urlimage: string = environment.baseUrlGalery;
  urlcv: string = environment.baseUrlGaleryCv;
  url: string = environment.baseUrl + '/api';
  headerChecked: boolean = false;
  pagination : boolean =false;

  selectedCandidats: any = [];
  backGroundColors: string[] = [
    'blue',
    'orange',
    'bleu-clair',
    'pink',
    'rose',
    'jaune',
    'rouge',
  ];
  sortAttr = '';
  searchForm!: FormGroup;
  freeSearchForm: FormGroup = this.createFreeSearchForm();
  applyForm: FormGroup = this.createapplyForm();
  skillsList: { name_FR: string }[] = [];
  dataHeader: any = [];
  listNames: string[] = [];
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  private unsubscribeAll: Subject<void> = new Subject();
  activeForm: 'freeSearch' | 'guidedSearch' | null = null;
  freeSearchActive :boolean = false;
  currentSortColumn: string = 'name'; // Initial column to sort by
  idoffre = this.activatedRoute.snapshot.params['id'];
  id: any;
  profile = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  passeport = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  state = [
    { id: 0, name: 'Actif' },
    { id: 1, name: 'Non Actif' },
  ];
  typeintervenant: any;
  modalRef?: BsModalRef;
  mobilities: any[] = [];
  isLoadSpinner: boolean = true;

  headerColumns: { checked: boolean; name: string; code: string }[] =
    headerColumns4;

  startSearching:boolean = false;
  candidateScoreDetail : any = null

  constructor(
    private formBuilder: FormBuilder,
    private cdRef: ChangeDetectorRef,
    private modalService: BsModalService,
    private candidatservice: EsnCandidatService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private salarieservice: SalarieService,
    private sortDataService: SortDataService,
    private activatedRoute: ActivatedRoute,
    private appelofferservice: EsnAppeloffreService,
    private localStorageService: LocalStorageService,
    private elRef: ElementRef,
    private datePipe: DatePipe,
    private jobofferservice: EsnJobOfferService,
    private esnconsultantservice: EsnConsultantService,
    private router: Router,
  ) {
    
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      this.redirectionCandidateName = navigation.extras.state['candidateFullName'];
      this.isNotifRedirection = true
    } 
    this.searchForm = this.createSearchForm();
  }
  ngOnInit() {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');
    this.typeintervenant = 
      this.localStorageService.getData('typeintervenant');
    this.countries = Country.getAllCountries();
    if(this.isNotifRedirection){
      this.searchCandidat()
      this.isNotifRedirection = false
    } else{
      this.getListcandidat();
    }
    this.getListclient();
    this.getListmanager();
    this.getListconsultant();
    this.getListSkills();
    this.getListElementHeader();

    this.formconsultant = this.formBuilder.group(
      {
        candidate_id: [''],
        first_name: ['', Validators.required],
        last_name: ['', Validators.required],
        email: [
          '',
          [
            Validators.required,
            Validators.email,
            Validators.pattern(patternEmail),
          ],
        ],
        emailProESN: ['', [Validators.email, Validators.pattern(patternEmail)]],
        linkedin_link: ['',Validators.pattern(linkedInRegExp)],
        cv: [''],
        desired_workstation: [''],
        date_signature_contrat: [''],
        mission_start_date: [{ value: '', disabled: true }],
        mission_end_date: [{ value: '', disabled: true }],
        salary_consultant: ['', [Validators.pattern(patternNumbersOnly)]],
        tjm_achat: ['', [Validators.pattern(patternNumbersOnly)]],
        tjm_vente: ['', [Validators.pattern(patternNumbersOnly)]],
        manager_id: [''],
        client_id: [''],
      },
      { validators: this.dateRangeValidator }
    );
    this.formconsultant = this.createconsultantForm();
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
    this.contrat = this.contrat.sort((a, b) => {
      return a.name === 'Autres type de contrat' ? 1 : b.name === 'Autres type de contrat' ? -1 : 0;
    });
    this.searchForm.get('start_date')?.valueChanges.subscribe((startDate) => {
      this.minEndDate = startDate ? new Date(startDate) : null;
    });
    this.searchForm.get('end_date')?.valueChanges.subscribe((endDate) =>{
      this.maxStartDate = endDate ? new Date(endDate) : null;
    })
  }
  dateRangeValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    const startDate = control.get('mission_start_date')!.value;
    const endDate = control.get('mission_end_date')!.value;

    if (startDate && endDate && startDate > endDate) {
      return { dateRangeInvalid: true };
    }

    return null;
  }
    createconsultantForm(data?: any) {
      return this.formBuilder.group(
        {
          first_name: [
            data?.candidat_first_name || '',
            [Validators.required, Validators.pattern(patternfirstNamechiffre)],
          ],
          last_name: [
            data?.candidat_last_name || '',
            [Validators.required, Validators.pattern(patternfirstNamechiffre)],
          ],
          emailProESN: [
            data?.emailProESN || '',
            [Validators.pattern(patternEmail)],
          ],
          email: [
            data?.candidat_email || '',
            [Validators.required, Validators.pattern(patternEmail)],
          ],
          linkedin_link: [data?.linkedin_link || ''],
          cv: [data?.cv || ''],
          desired_workstation: [data?.name || ''],
          date_signature_contrat: [data?.date_signature_contrat || ''],
          salary_consultant: [data?.salary_consultant || null],
          tjm_achat: [data?.tjm_achat || ''],
          tjm_vente: [data?.tjm_vente || ''],
          manager_id: [data?.manager_id || null],
          client_id: [data?.client_id?data?.client_id:data?.client_id2 || null],
          candidate_id: [data?.candidate_id || ''],
          mission_start_date: [{ value: '', disabled: true }],
          mission_end_date: [{ value: '', disabled: true }],
          mobility: [data?.candidat_mobility || []],
          desired_contract: [data?.candidat_desired_contract || []],
          softSkills: [data?.candidate_skills || []],
          destination_country: [data?.destination_country || []],
          contract_type: [data?.contract_type || []],
          skills_text: [data?.skills_text || []],
        },
        { validator: this.dateRangeValidator }
      );
    }
  createFreeSearchForm(){
    return this.formBuilder.group({
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
    });
  }
    setActiveForm(form: 'freeSearch' | 'guidedSearch') {
    this.activeForm = form;
    if (form === 'freeSearch') {
      this.freeSearchActive = true;
      this.freeSearchForm.enable(); 
    } else if (form === 'guidedSearch') {
      this.freeSearchActive = false;
      this.searchForm.enable();
    }
}
   onSubmit() {
    if(!this.freeSearchActive) { 
      this.btnSearchactive = true;
      this.currentPage = 0;
      this.searchCandidat(1);
    } else{
      this.btnSearchactive = true;
      this.currentPage = 0;
      this.freeSearchCandidat(1);
    }
  }
  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');
    
    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
    }
  }
  navigateToProfile(consultantUuid: any) {
    this.router.navigate([
      '/candidats/profilecandidatesn',
      consultantUuid,
    ]);
  }

   getListconsultant(sort?: ISort) {
      this.spinner.show();
      let dataPyload = {
              per_page: this.pageSize,
              page: this.currentPage,
          };
  
      this.esnconsultantservice.getListconsultant(dataPyload).subscribe({
        next: (response: any) => {
          this.spinner.hide();
          if (response.data && response.data.data) {
            this.listconsultant = response.data.data
            this.formconsultant
              .get('salary_consultant')
              ?.setValue(this.listconsultant.consultant_e_s_n_s_Salary);
            this.clientId2_name=response.data.data.clientId2_name
            this.totalItems = response.data.total;
          }
        },
        error: (error: any) => {
          if (error.error.message) {
            this.toastrService.error(error.error.message);
          }
          this.spinner.hide();
        },
      });
    }
    uploadFile(event: any) {
      this.file = event.target.files[0];
      const maxSize = 2 * 1024 * 1024;
      this.fileName = this.file.name;
      if (this.file) {
        const allowedExtensions = ['.pdf', '.docx', '.doc'];
        const fileExtension = this.file.name
          .toLowerCase()
          .substr(this.file.name.lastIndexOf('.'));
  
        if (!allowedExtensions.includes(fileExtension)) {
          this.fileExtention = 'Format fichier non compatible !';
        } else if (this.file.size > maxSize) {
          this.fileError = 'Le fichier à importer ne doit pas depasser 2 méga !';
        } else {
          this.fileError = '';
          this.fileExtention = '';
        }
      }
      this.formconsultant.get('cv')?.setValue(this.file);
    }
    
  resetCV() {
    const inputFile = document.getElementById('cv') as HTMLInputElement;
    if (inputFile) {
      inputFile.value = '';
      this.fileExtention = '';
      this.fileError = '';
      this.isvalid = true;
    }
    this.fileName = '';
    this.showResetButtons = true;
  }
  createconsultant() { 
    this.formconsultant.markAllAsTouched();
    this.formconsultant.markAsDirty();
    this.setValidatorRequirements();

    if (!this.isexistemail) {

      let fromdata = new FormData();
      fromdata.append('first_name', this.formconsultant.value.first_name);
      fromdata.append('last_name', this.formconsultant.value.last_name);
      fromdata.append('email', this.formconsultant.value.email);
      if (this.formconsultant.value.emailProESN) {
        fromdata.append('emailProESN', this.formconsultant.value.emailProESN);
      }
      if(this.formconsultant.value.date_signature_contrat)
      {
        fromdata.append('date_signature_contrat', this.formconsultant.value.date_signature_contrat);
      }
      if(this.formconsultant.value.linkedin_link){
      fromdata.append('linkedin_link', this.formconsultant.value.linkedin_link)
      };
      if( this.formconsultant.value.desired_workstation)
      {
        fromdata.append('desired_workstation',this.formconsultant.value.desired_workstation );
      }
      if (this.formconsultant.value.tjm_achat) {
        fromdata.append('tjm_achat', this.formconsultant.value.tjm_achat);
      }
      if (this.formconsultant.value.tjm_vente) {
        fromdata.append('tjm_vente', this.formconsultant.value.tjm_vente);
      }
      if (this.formconsultant.value.salary_consultant) {
        fromdata.append('salary_consultant', this.formconsultant.value.salary_consultant);
      }
      if (this.formconsultant.value.manager_id) {
        fromdata.append('manager_id', this.formconsultant.value.manager_id);
      }
      if (this.formconsultant.value.client_id) {
        fromdata.append('client_id', this.formconsultant.value.client_id);
      } 
      if (this.file) {
        fromdata.append('cv', this.file);
      } 

      if (this.formconsultant.invalid) {
        return;
      }
      this.enableFormFields();
      this.esnconsultantservice.createconsultant(fromdata).subscribe({
        next: (response) => {
          this.toastrService.success('consultant a été ajouté avec succès');
          this.navigateToProfile(response.data?.user_id);

          this.getListconsultant();
          this.close_modal_add();
        },
        error: (error: any) => {
          if (error?.status === 404) {
            this.toastrService.error('Utilisateur associé à une autre ESN.');
          } else if (error.error.message && typeof error.error.message === 'string') {
            this.toastrService.error(error.error.message);
          } else if (error?.error && error?.error?.data) {
            if (
              error.error.data.email &&
              error.error.data.email[0] === 'The email has already been taken.'
            ) {
              this.toastrService.error("L'email est déjà utilisé.");
            } else if (
              error.error.data.linkedin_link &&
              error.error.data.linkedin_link[0] ===
                'The linkedin link must be a valid URL.'
            ) {
              this.toastrService.error(
                'Le lien LinkedIn doit être une URL valide.'
              );
            } else if (
              error.error.data.cv &&
              error.error.data.cv[0] === 'The cv field is required.'
            ) {
              this.toastrService.error('Le CV est requis.');
            } else if (
              error.error.data.linkedin_link &&
              error.error.data.linkedin_link[0] ===
                'The linkedin link has already been taken.'
            ) {
              this.toastrService.error('LinkedIn est déjà utilisé.');
            } else  if (error.status === 403 && error.error.message) {
              this.toastrService.error(error.error.message);
          } else {
            this.toastrService.error("Une erreur inattendue s'est produite.");
          }
          }}

      });
    }
    else {
      if (this.company_name == null) {
        let data = {
          candidate_id: this.candidat_id,
          salary_consultant: this.formconsultant.value.salary_consultant,

          tjm_achat: this.formconsultant.value.tjm_achat,
          tjm_vente: this.formconsultant.value.tjm_vente,
          emailProESN: this.formconsultant.value.emailProESN,
          mission_start_date: this.formconsultant.value.mission_start_date,
          mission_end_date: this.formconsultant.value.mission_end_date,
          manager_id: this.formconsultant.value.manager_id
            ? this.formconsultant.value.manager_id
            : '',
          client_id: this.formconsultant.value.client_id
            ? this.formconsultant.value.client_id
            : '',
          date_signature_contrat:
            this.formconsultant.value.date_signature_contrat,
          desired_workstation: this.formconsultant.value.desired_workstation,
        };
        this.disableFormFields();
        this.esnconsultantservice.createconsultant(data).subscribe({
          next: (response) => {
            this.toastrService.success('consultant a été ajouté avec succès ');

            this.getListconsultant();

            this.close_modal_add();
          },
          error: (error: any) => {
            if (error?.status === 404) {
              this.toastrService.error('Utilisateur associé à une autre ESN.');
            } else if (error?.error && error?.error?.data) {
              if (
                error.error.data.email &&
                error.error.data.email[0] ===
                  'The email has already been taken.'
              ) {
                this.toastrService.error("L'email est déjà utilisé.");
              } else if (
                error.error.data.linkedin_link &&
                error.error.data.linkedin_link[0] ===
                  'The linkedin link must be a valid URL.'
              ) {
                this.toastrService.error(
                  'Le lien LinkedIn doit être une URL valide.'
                );
              } else if (
                error.error.data.cv &&
                error.error.data.cv[0] === 'The cv field is required.'
              ) {
                this.toastrService.error('Le CV est requis.');
              } else if (
                error.error.data.linkedin_link &&
                error.error.data.linkedin_link[0] ===
                  'The linkedin link has already been taken.'
              ) {
                this.toastrService.error("L'linkedin est déjà utilisé.");
              }
              else if (
                error.error && error.error.message ==='candidate was already a salary'
              ) {
                this.toastrService.error("La candidate est déjà salariée.");
              }else {
                this.toastrService.error(
                  "Une erreur inattendue s'est produite."
                );
              }
            } else {
              this.toastrService.error("Une erreur inattendue s'est produite.");
            }
          },
        });
      } else {
        let data = {
          candidate_id: this.candidat_id,
          salary_consultant: this.formconsultant.value.salary_consultant,
          tjm_achat: this.formconsultant.value.tjm_achat,
          tjm_vente: this.formconsultant.value.tjm_vente,

          emailProESN: this.formconsultant.value.emailProESN,
          mission_start_date: this.formconsultant.value.mission_start_date,
          mission_end_date: this.formconsultant.value.mission_end_date,
          manager_id: this.formconsultant.value.manager_id
            ? this.formconsultant.value.manager_id
            : '',
          client_id: this.formconsultant.value.client_id
            ? this.formconsultant.value.client_id
            : '',
          date_signature_contrat:
            this.formconsultant.value.date_signature_contrat,
        };
        this.disableFormFields();
        this.esnconsultantservice.createconsultant(data).subscribe({
          next: (response) => {
            this.toastrService.success('consultant a été ajouté avec succès ');

            this.getListconsultant();

            this.close_modal_add();
          },
          error: (error: any) => {
            this.toastrService.error(`Une erreur inattendue s'est produite. ${error.error.message}`);
            if (error?.status === 404) {
              this.toastrService.error('Utilisateur associé à une autre ESN.');
            } else if (error?.error && error?.error?.data) {
              if (
                error.error.data.email &&
                error.error.data.email[0] ===
                  'The email has already been taken.'
              ) {
                this.toastrService.error("L'email est déjà utilisé.");
              } else if (
                error.error.data.linkedin_link &&
                error.error.data.linkedin_link[0] ===
                  'The linkedin link must be a valid URL.'
              ) {
                this.toastrService.error(
                  'Le lien LinkedIn doit être une URL valide.'
                );
              } else if (
                error.error.data.cv &&
                error.error.data.cv[0] === 'The cv field is required.'
              ) {
                this.toastrService.error('Le CV est requis.');
              } else if (
                error.error.data.linkedin_link &&
                error.error.data.linkedin_link[0] ===
                  'The linkedin link has already been taken.'
              ) {
                this.toastrService.error("L'linkedin est déjà utilisé.");
              } else {
                this.toastrService.error(
                  "Une erreur inattendue s'est produite."
                );
              }
            } else {
              this.toastrService.error("Une erreur inattendue s'est produite.");
            }
          },
        });
      }
    }
  }
  isDateRangeValid(): boolean {
    return !this.formconsultant.hasError('dateRangeInvalid');
  }
  getListmanager() {
    this.esnconsultantservice.getmanagernew().subscribe({
      next: (response) => {
        if (response.data) {
          this.listmanager = response.data.map((el: any) => {
            return {
              ...el,
              full_name: `${el.first_name} ${el.last_name}`
            };
          });
        }
      },
      error: (error) => {
      },
    });
  }
  getListclient() {
    this.esnconsultantservice.getclient().subscribe({
      next: (response) => {
        if (response.data) {
          this.listclient = response.data;
          this.client = response.data;
          this.clientList = this.client.map(item=> item.name);
        }
      },
      error: (error) => {
      },
    });
  }
  setValidatorRequirements() {
    const linkedinControl = this.formconsultant.get('linkedin_link');
    const cvControl = this.formconsultant.get('cv');
    // Effacer les validateurs existants
    linkedinControl?.clearValidators();
    cvControl?.clearValidators();

    if (!linkedinControl?.value && !cvControl?.value) {
      linkedinControl?.setValidators([
        Validators.pattern(linkedInRegExp),
      ]);
    } else {
      if (linkedinControl?.value) {
        linkedinControl?.setValidators([Validators.pattern(linkedInRegExp)]);
      }
      if (cvControl?.value) {
        cvControl?.clearValidators();
        // linkedinControl?.clearValidators();
      }
    }
    linkedinControl?.updateValueAndValidity({ emitEvent: false });
    cvControl?.updateValueAndValidity({ emitEvent: false });
  }
  disableFormFields() {
    if (this.formconsultant) {
      this.formconsultant.get('first_name')?.disable();
      this.formconsultant.get('last_name')?.disable();
    }
  }
  getconsultantByEmail(event: any) {
    this.errorMessage = '';
    //this.formconsultant.reset();
    const enteredEmail = event.target.value.trim();
    if (enteredEmail === '') {
      this.enableFormFields();
      this.formconsultant.get('linkedin_link')?.enable();
      this.selectedconsultant = '';
      this.formconsultant.patchValue({
        first_name: '',
        last_name: '',
        linkedin_link: '',
        cvName: '',
        desired_workstation: '',
      });
      this.isexistemail = false;
      this.isButtonDisabled = false;
      this.errorMessage = '';
      return;
    }

    this.esnconsultantservice
      .getconsultantbyemail(enteredEmail)
      .subscribe({
        next: (res: any) => {
          if (res.status === 200) {
            this.isexistemail = true;
            if(res.data.cv && res.data.cv!=='null'){
              this.iscv=true
             }
             else{
              this.iscv=false
             }

            this.formconsultant.get('linkedin_link')?.enable();
            this.company_name = res.company_name;
            this.selectedconsultant = res.data.cv;
            this.candidat_id = res.data.uuid;
            if (enteredEmail !== res.data.email) {
              this.formconsultant.get('linkedin_link')?.enable();
              this.formconsultant.patchValue({
                first_name: '',
                last_name: '',
                selectedconsultant: '',
                desired_workstation: '',
              });
              this.isexistemail = false;
              this.isButtonDisabled = false;
              this.errorMessage = '';
              return;
            }

            this.formconsultant.patchValue({
              email: res.data.email,
              first_name: res.data.first_name,
              last_name: res.data.last_name,
              linkedin_link: res.data.linkedin_link,
              cv: res.data.cv,
              desired_workstation: res.data.desired_workstation,
              client_name: res.client_name,
            });
            if (res.data.cv) {
              this.file = { name: res.data.cv };
            }

            this.errorMessage = '';
            this.isButtonDisabled = false;

            if (
              res.data.linkedin_link !== null &&
              res.data.linkedin_link !== ''
            ) {
              this.formconsultant.get('linkedin_link')?.disable();
            } else {
              this.formconsultant.get('linkedin_link')?.enable();
            }

            this.disableFormFields();
          } else {
            this.isexistemail = true;

            this.isButtonDisabled = true;
            this.errorMessage = '"Utilisateur associé à une autre ESN."';
          }
        },
        error: (error: any) => {
          this.isexistemail = false;
          this.iscv=false
          this.enableFormFields()
          this.formconsultant.patchValue({
            first_name: '',
            last_name: '',
            selectedconsultant: '',
            desired_workstation: '',
            cv:'',
            linkedin_link:'',
          });
          if (
            error?.error?.message === 'User already associated with this ESN'
          ) {
            this.isexistemail = true;
            this.isButtonDisabled = true;
            this.errorMessage = '"Utilisateur associé à cet ESN."';
          }
          if (error?.error?.message === 'User associated with another ESN') {
            this.isexistemail = true;
            this.isButtonDisabled = true;
            this.errorMessage = '"Utilisateur associé à une autre ESN."';
          }
          if (error?.error?.message === 'User profile was not completed') {
            this.isexistemail = true;
            this.isButtonDisabled = true;
            this.errorMessageprofil = '"Le profil utilisateur n\'a pas été complété"';
          }
        },
      });
    if (
      this.formconsultant.value.linkedin_link === undefined &&
      this.formconsultant.value.cv === undefined &&
      this.formconsultant.value.cv !== null &&
      this.formconsultant.value.linkedin_link !== null
    ) {
      this.isvalid = true;
    } else {
      this.isvalid = false;
    }
  }

  onSalaryRangeInput(event: any) {
    const value = event.target.value;
    if (value.toLowerCase().endsWith('k')) {
      this.searchForm.controls['desired_salary_range'].setValue(
        this.convertKToNumber(value)
      );
    }
  }
 
 alreadyConverted = false;
 convertKToNumber(value: any): number {
  if (typeof value === 'string' && value.toLowerCase().endsWith('k')) {
    // Si la valeur se termine par 'k'
    const numericValue = parseFloat(value.slice(0, -1));
    if (!isNaN(numericValue)) {
      // Convertir en multipliant par 1000
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return numericValue * 1000;
    }
  } else if (!isNaN(value)) {
    // Si la valeur est déjà un nombre
    if (!this.alreadyConverted) {
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return parseFloat(value) * 1000;
    } else {
      return parseFloat(value); // Retourner la valeur sans multiplier à nouveau
    }
  }

  // Si aucune condition n'est remplie, retourner une valeur par défaut
  return 0; // Ou une autre valeur par défaut appropriée
}
  sortData(item: string) {
    for (const iterator of headerColumns4) {
      if (item == iterator.name) item = iterator.code;
    }
    this.sortAttr = item;
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;

    if (this.searchForm.dirty)
      this.listcandidats = this.sortDataService.sortArray(
        this.listcandidats,
        item,
        this.currentSortDirection
      );
    else this.getListcandidat();
  }
  onPageChange(e: PageEvent): void {
    this.pageSize = e.pageSize;
    this.currentPage = e.pageIndex;
    if (this.searchForm.dirty && this.btnSearchactive) {
      this.searchCandidat(this.currentPage);
    } 
     else if (this.freeSearchForm.dirty){
    this.freeSearchCandidat(this.currentPage);
  }
    else {
      this.getListcandidat();
    }
  }
  displayFreeSearch() {
    this.freeSearch = !this.freeSearch;
    this.currentPage = 0;
    if(this.freeSearch) {
      this.searchForm = this.createSearchForm();
      this.searchForm.reset();
      this.getListcandidat();
   }
   else {
     this.freeSearchForm.reset();
     this.freeSearchForm = this.createFreeSearchForm();
     this.getListcandidat();
   }
  }
  getSkillsArray(c: any): string[] {
    if (c && c.candidate_skills) {
      return c.candidate_skills.split(',').map((s: string) => s.trim());
    } else {
      return [];
    }
  }
  getSkillsList(candidate_skills: string): string {
    if (!candidate_skills) {
      return '';
    }
    return candidate_skills.split(',').map(s => s.trim()).join(', ');
  }
  getRemainingPays(pay: any): string {
    if (!Array.isArray(pay) || pay.length <= 3) {
      return ''; 
    }
    return pay.map(m => String(m)).join(', '); 
  }
  getListElementHeader() {   
    if (!this.typeintervenant) {
      this.appelofferservice
        .getHeaderElements(17)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.isLoadSpinner = false;
            this.dataHeader = res.data;
            for (const iterator of this.dataHeader) {
              const nameLower = iterator.name?.toLowerCase?.();
              if (
                !(nameLower === 'score barème' && iterator.checked_user === null) && // <-- exclusion condition
                (
                  (iterator.checked === 'oui' && !iterator.checked_user) ||
                  (iterator.checked === 'non' && iterator.checked_user === 'oui') ||
                  (iterator.checked === 'oui' && iterator.checked_user === 'oui')
                )
              ) {
                this.listNames.push(iterator.name);
              }
            }
            
             this.dataHeader.map((el: any) => {
              if (el.name.toLowerCase() === 'score barème' && el.checked_user === null) {
                return (el.checkAdmin = false);
              } else if (
                (el.checked == 'oui' && !el.checked_user) ||
                (el.checked_user == 'oui' &&
                  (el.checked == 'non' || el.checked == 'oui'))
              ) {
                return (el.checkAdmin = true);
              } else {
                return (el.checkAdmin = false);
              }
            });
          },
          error: () => {},
        });
    } else {
      this.appelofferservice
        .listPageActorcandidatureoffreemploiIntervenant()
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.isLoadSpinner = false;
            this.dataHeader = res.data;
            for (const iterator of this.dataHeader) {
              const nameLower = iterator.name?.toLowerCase?.();

              if (
                !(nameLower === 'score barème' && iterator.checked_user === null) &&
                (
                  (iterator.checked === 'oui' && !iterator.checked_user) ||
                  (iterator.checked === 'non' && iterator.checked_user === 'oui') ||
                  (iterator.checked === 'oui' && iterator.checked_user === 'oui')
                )
              ) {
                this.listNames.push(iterator.name);
              }
            }
            this.dataHeader.map((el: any) => {
              if (el.name.toLowerCase() === 'score barème' && el.checked_user === null) {
                return (el.checkAdmin = false);
              } else if (
                (el.checked == 'oui' && !el.checked_user) ||
                (el.checked_user == 'oui' &&
                  (el.checked == 'non' || el.checked == 'oui'))
              ) {
                return (el.checkAdmin = true);
              } else {
                return (el.checkAdmin = false);
              }
            });
          },
          error: () => {},
        });
    }
  }

  changeSelection(event: any, data: any, i: number) {
      if(data?.name?.toLowerCase() ==="score barème" && event.target.checked){
        Swal.fire({
              title: `Conformément à la réglementation RGPD, cette fonctionnalité ne peut être activée que si vous avez reçu plus de 50 candidatures. Souhaitez-vous continuer ?`,
              icon: 'info',
              showCancelButton: true,
              confirmButtonText: 'Confirmer',
              cancelButtonText: 'Annuler',
              reverseButtons: true,
              iconColor: '#265D91',
              confirmButtonColor: '#265D91',
            }).then((result) => {
              if (result.isConfirmed) {
                this.toastrService.success('La colonne "Score Barème" a été activée avec succès.');
                this.listNames = [];
                data.checkAdmin = event.target.checked;
                for (const iterator of this.dataHeader) {
                  if (iterator.checkAdmin) this.listNames.push(iterator.name);
                }
                this.changeSelectionHeadrElements(data);
              } else {
                event.target.checked = false; // Annuler la sélection
                data.checkAdmin = false;
                this.listNames = [];
                for (const iterator of this.dataHeader) {
                  if (iterator.checkAdmin) this.listNames.push(iterator.name);
                }
              }
            });
      } else{
        this.listNames = [];
        data.checkAdmin = event.target.checked;
        for (const iterator of this.dataHeader) {
          if (iterator.checkAdmin) this.listNames.push(iterator.name);
        }
        this.changeSelectionHeadrElements(data);
    
      }
    }
    
  changeSelectionHeadrElements(data: any) {
    if (!this.typeintervenant) {
      let payload = {
        sub_page_id: data?.id,
        state: data?.checkAdmin? 1 : 0,
      };
      this.appelofferservice
        .changeDelectedElementHeader(payload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {},
          error: () => {},
        });
    } else {
      let payload = {
        sub_page_id: data?.id,
        state: data?.checkAdmin? 1 : 0,
      };
      this.appelofferservice
        .changeDelectedElementHeader(payload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {},
          error: () => {},
        });
    }
  }
  getListcandidat() {
    this.spinner.show();
    const params = {
      id: this.idclientConnected,
      per_page: this.pageSize,
      page: this.currentPage} 
    this.candidatservice.getListcandidatureoffre(params).subscribe({
      next: (response) => {
        if (response.data && response.data.data) {
          this.listcandidats = response.data.data
          this.totalCandidateItems = response.data.total;
          this.spinner.hide();
        }
      },
      error: (error) => {
        this.spinner.hide();
      },
    });
  }
  downloadFile(type: string, candidat?: any, typeFile?: string) {
    if (type == 'single' && candidat) {
      if (candidat.cv || candidat.file_test) {
        if (typeFile && typeFile != '')
          candidat.file_test = candidat.file_test.split('/')[1];
        const fileUrl = !typeFile
          ? `${this.url}/User/file/gallery_cvs/${candidat.cv}`
          : `${this.url}/ResponseCandidate/GetFile/${candidat.file_test}`; // Replace with your file URL
        this.showGlobalSpinner();
        this.candidatservice.downloadPDF(fileUrl).subscribe(
          (data) => {
            const blob = new Blob([data], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = !typeFile
              ? `${candidat.ID_user}_${candidat.first_name}_${
                  candidat.last_name
                }_CV.${candidat!.cv.split('.').pop()}`
              : `${candidat.ID_user}_${candidat.first_name}_${
                  candidat.last_name
                }_QCM.${candidat!.file_test.split('.').pop()}`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            this.hideGlobalSpinner();
          },
          () => {
            this.hideGlobalSpinner();
          }
        );
      } else {
        this.toastrService.info(EmptyCV);
      }
    } else if (this.selectedCandidats.length) {
      if (this.selectedCandidats.length == 1 && !this.selectedCandidats[0].cv) {
        this.toastrService.info(EmptyCV);
      } else this.downloadPdfFiles(typeFile);
    } else {
      this.toastrService.info(obligationSelect);
    }
  }
  /* download files in zip folder */
  downloadPdfFiles(typeFile?: string) {
    const zip = new JSZip();
    const fileUrls = this.selectedCandidats.map(
      (el: {
        cv: string;
        file_test: string;
        first_name: string;
        last_name: string;
        ID_user: string;
      }) => {
        if (!typeFile) {
          return {
            url: `${this.url}/User/file/gallery_cvs/${el.cv}`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            cv: el.cv,
          };
        } else {
          // if(el.file_test!=null)
          return {
            url: `${this.url}/ResponseCandidate/GetFile/${
              el?.file_test?.split('/')[1]
            }`,
            first_name: el.first_name,
            last_name: el.last_name,
            ID_user: el.ID_user,
            response: el?.file_test?.split('/')[1],
          };
        }
      }
    );
    this.showGlobalSpinner();
    const downloadPromises = fileUrls.map((pdfUrl: any) => {
      return this.candidatservice
        .getPdfContent(pdfUrl.url)
        .toPromise()
        .then(
          (pdfContent: any) => {
            this.hideGlobalSpinner();
            zip.file(
              !typeFile
                ? `${pdfUrl.ID_user}_${pdfUrl.first_name}_${
                    pdfUrl.last_name
                  }_CV.${pdfUrl.cv.split('.').pop()}`
                : `${pdfUrl.ID_user}_${pdfUrl.first_name}_${
                    pdfUrl.last_name
                  }_QCM.${pdfUrl.response.split('.').pop()}`,
              pdfContent
            );
          },
          (err: any) => {
            this.hideGlobalSpinner();
          }
        );
    });

    Promise.all(downloadPromises).then(() => {
      zip.generateAsync({ type: 'blob' }).then((content) => {
        if (!typeFile) {
          saveAs(content, 'RH_Profiles_CVs.zip'); // Specify the zip file name here
        } else {
          saveAs(content, 'RH_Profiles_QCMs.zip');
        }
      });
    });
  }
  showGlobalSpinner() {
    this.loadSpinner = true;
    this.spinner.show();
  }
  hideGlobalSpinner() {
    this.loadSpinner = false;
    this.spinner.hide();
  }
  translateCountryName(name: string): string {
    const translations: { [key: string]: string } = {
      Afghanistan: 'Afghanistan',
      'South Africa': 'Afrique du Sud',
      Albania: 'Albanie',
      Algeria: 'Algérie',
      Germany: 'Allemagne',
      Andorra: 'Andorre',
      Angola: 'Angola',
      Anguilla: 'Anguilla',
      Antarctica: 'Antarctique',
      'Antigua and Barbuda': 'Antigua-et-Barbuda',
      'Saudi Arabia': 'Arabie saoudite',
      Argentina: 'Argentine',
      Armenia: 'Arménie',
      Aruba: 'Aruba',
      Australia: 'Australie',
      Austria: 'Autriche',
      Azerbaijan: 'Azerbaïdjan',
      Bahamas: 'Bahamas',
      Bahrain: 'Bahreïn',
      Bangladesh: 'Bangladesh',
      Barbados: 'Barbade',
      Belgium: 'Belgique',
      Belize: 'Belize',
      Benin: 'Bénin',
      Bermuda: 'Bermudes',
      Bhutan: 'Bhoutan',
      Belarus: 'Biélorussie',
      Bolivia: 'Bolivie',
      'Bosnia and Herzegovina': 'Bosnie-Herzégovine',
      Botswana: 'Botswana',
      Brazil: 'Brésil',
      Brunei: 'Brunei',
      Bulgaria: 'Bulgarie',
      'Burkina Faso': 'Burkina Faso',
      Burundi: 'Burundi',
      'Cape Verde': 'Cabo Verde',
      Cambodia: 'Cambodge',
      Cameroon: 'Cameroun',
      Canada: 'Canada',
      Chile: 'Chili',
      China: 'Chine',
      Cyprus: 'Chypre',
      Colombia: 'Colombie',
      Comoros: 'Comores',
      'Congo - Brazzaville': 'Congo-Brazzaville',
      'Congo - Kinshasa': 'Congo-Kinshasa',
      'North Korea': 'Corée du Nord',
      'South Korea': 'Corée du Sud',
      'Costa Rica': 'Costa Rica',
      'Ivory Coast': 'Côte d’Ivoire',
      Croatia: 'Croatie',
      Cuba: 'Cuba',
      Curaçao: 'Curaçao',
      Denmark: 'Danemark',
      Djibouti: 'Djibouti',
      Dominica: 'Dominique',
      'Dominican Republic': 'République dominicaine',
      Ecuador: 'Équateur',
      Egypt: 'Égypte',
      'United Arab Emirates': 'Émirats arabes unis',
      Eritrea: 'Érythrée',
      Spain: 'Espagne',
      Eswatini: 'Eswatini',
      Estonia: 'Estonie',
      'United States': 'États-Unis',
      Ethiopia: 'Éthiopie',
      Fiji: 'Fidji',
      Finland: 'Finlande',
      France: 'France',
      Gabon: 'Gabon',
      Gambia: 'Gambie',
      Georgia: 'Géorgie',
      Ghana: 'Ghana',
      Gibraltar: 'Gibraltar',
      Greece: 'Grèce',
      Grenada: 'Grenade',
      Greenland: 'Groenland',
      Guadeloupe: 'Guadeloupe',
      Guam: 'Guam',
      Guatemala: 'Guatemala',
      Guernsey: 'Guernesey',
      Guinea: 'Guinée',
      'Guinea-Bissau': 'Guinée-Bissau',
      'Equatorial Guinea': 'Guinée équatoriale',
      Guyana: 'Guyana',
      'French Guiana': 'Guyane française',
      Haiti: 'Haïti',
      Honduras: 'Honduras',
      'Hong Kong': 'Hong Kong',
      Hungary: 'Hongrie',
      Iceland: 'Islande',
      India: 'Inde',
      Indonesia: 'Indonésie',
      Iraq: 'Irak',
      Iran: 'Iran',
      Ireland: 'Irlande',
      'Isle of Man': 'Île de Man',
      Italy: 'Italie',
      Jamaica: 'Jamaïque',
      Japan: 'Japon',
      Jersey: 'Jersey',
      Jordan: 'Jordanie',
      Kazakhstan: 'Kazakhstan',
      Kenya: 'Kenya',
      Kiribati: 'Kiribati',
      Kuwait: 'Koweït',
      Kyrgyzstan: 'Kirghizistan',
      Laos: 'Laos',
      Latvia: 'Lettonie',
      Lebanon: 'Liban',
      Lesotho: 'Lesotho',
      Liberia: 'Libéria',
      Libya: 'Libye',
      Liechtenstein: 'Liechtenstein',
      Lithuania: 'Lituanie',
      Luxembourg: 'Luxembourg',
      Macao: 'Macao',
      'North Macedonia': 'Macédoine du Nord',
      Madagascar: 'Madagascar',
      Malawi: 'Malawi',
      Malaysia: 'Malaisie',
      Maldives: 'Maldives',
      Mali: 'Mali',
      Malta: 'Malte',
      'Marshall Islands': 'Îles Marshall',
      Martinique: 'Martinique',
      Mauritania: 'Mauritanie',
      Mauritius: 'Maurice',
      Mayotte: 'Mayotte',
      Mexico: 'Mexique',
      Micronesia: 'Micronésie',
      Moldova: 'Moldavie',
      Monaco: 'Monaco',
      Mongolia: 'Mongolie',
      Montenegro: 'Monténégro',
      Montserrat: 'Montserrat',
      Morocco: 'Maroc',
      Mozambique: 'Mozambique',
      Myanmar: 'Myanmar',
      Namibia: 'Namibie',
      Nauru: 'Nauru',
      Nepal: 'Népal',
      Netherlands: 'Pays-Bas',
      'New Caledonia': 'Nouvelle-Calédonie',
      'New Zealand': 'Nouvelle-Zélande',
      Nicaragua: 'Nicaragua',
      Niger: 'Niger',
      Nigeria: 'Nigeria',
      Niue: 'Niue',
      'Norfolk Island': 'Île Norfolk',
      'Northern Mariana Islands': 'Îles Mariannes du Nord',
      Norway: 'Norvège',
      Oman: 'Oman',
      Pakistan: 'Pakistan',
      Palau: 'Palaos',
      Palestine: 'Palestine',
      Panama: 'Panama',
      'Papua New Guinea': 'Papouasie-Nouvelle-Guinée',
      Paraguay: 'Paraguay',
      Peru: 'Pérou',
      Philippines: 'Philippines',
      'Pitcairn Islands': 'Îles Pitcairn',
      Poland: 'Pologne',
      Portugal: 'Portugal',
      'Puerto Rico': 'Porto Rico',
      Qatar: 'Qatar',
      Romania: 'Roumanie',
      Russia: 'Russie',
      Rwanda: 'Rwanda',
      Réunion: 'Réunion',
      'Saint Barthélemy': 'Saint-Barthélemy',
      'Saint Helena': 'Sainte-Hélène',
      'Saint Kitts and Nevis': 'Saint-Kitts-et-Nevis',
      'Saint Lucia': 'Sainte-Lucie',
      'Saint Martin': 'Saint-Martin',
      'Saint Pierre and Miquelon': 'Saint-Pierre-et-Miquelon',
      'Saint Vincent and the Grenadines': 'Saint-Vincent-et-les-Grenadines',
      Samoa: 'Samoa',
      'San Marino': 'Saint-Marin',
      'Sao Tome and Principe': 'Sao Tomé-et-Principe',
      Senegal: 'Sénégal',
      Serbia: 'Serbie',
      Seychelles: 'Seychelles',
      'Sierra Leone': 'Sierra Leone',
      Singapore: 'Singapour',
      'Sint Maarten': 'Saint-Martin',
      Slovakia: 'Slovaquie',
      Slovenia: 'Slovénie',
      'Solomon Islands': 'Îles Salomon',
      Somalia: 'Somalie',
      'South Georgia and the South Sandwich Islands':
        'Géorgie du Sud-et-les Îles Sandwich du Sud',
      'South Sudan': 'Soudan du Sud',
      'Sri Lanka': 'Sri Lanka',
      Sudan: 'Soudan',
      Suriname: 'Suriname',
      'Svalbard and Jan Mayen': 'Svalbard et Jan Mayen',
      Swaziland: 'Eswatini',
      Sweden: 'Suède',
      Switzerland: 'Suisse',
      Syria: 'Syrie',
      Taiwan: 'Taïwan',
      Tajikistan: 'Tadjikistan',
      Tanzania: 'Tanzanie',
      Thailand: 'Thaïlande',
      'Timor-Leste': 'Timor-Leste',
      Togo: 'Togo',
      Tokelau: 'Tokelau',
      Tonga: 'Tonga',
      'Trinidad and Tobago': 'Trinité-et-Tobago',
      Tunisia: 'Tunisie',
      Turkey: 'Turquie',
      Turkmenistan: 'Turkménistan',
      Tuvalu: 'Tuvalu',
      Uganda: 'Ouganda',
      Ukraine: 'Ukraine',
      'United Kingdom': 'Royaume-Uni',
      Uruguay: 'Uruguay',
      Uzbekistan: 'Ouzbékistan',
      Vanuatu: 'Vanuatu',
      'Vatican City': 'Vatican',
      Venezuela: 'Venezuela',
      Vietnam: 'Viêt Nam',
      'Western Sahara': 'Sahara occidental',
      Yemen: 'Yémen',
      Zambia: 'Zambie',
      Zimbabwe: 'Zimbabwe',
    };
    return translations[name] || name;
  }
  downloadreponse(candidat: any) {
    // if(!this.selectedCandidate.cv) {this.toastr.info(EmptyCV)}
    // else{
    this.spinner.show();
    const fileUrl = `${this.url}/User/file/gallery_cvs/${candidat.file_test}`;
    this.candidatservice.downloadPDF(fileUrl).subscribe((blob) => {
      const fileURL = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = fileURL;
      a.download = `${candidat.ID_user}_${candidat.first_name}_${
        candidat.last_name
      }_CV.${candidat.cv.split('.').pop()}`;
      document.body.appendChild(a);
      a.click();
      this.spinner.hide();
    });
    // }
  }
  /* get candidats selected */
  fromSelection: boolean = false;
  changeSelectCandidats(event: any, type: string, candidat?: ICandidat) {
    if (type === 'allCandidats') {
      this.fromSelection = event.target.checked ? true : false;
      this.headerChecked = event.target.checked;
      this.selectedCandidats = event.target.checked
        ? [...this.listcandidats]
        : [];

      // Mettez à jour la propriété checked pour chaque candidat dans selectedCandidats
      this.selectedCandidats.forEach((el: ICandidat) => {
        el.checked = event.target.checked;
      });
    } else {
      if (candidat) {
        if (event.target.checked) {
          this.selectedCandidats.push(candidat);
          candidat.checked = true; // Mettez à jour la propriété checked pour le candidat spécifique
        } else {
          let indexId = this.selectedCandidats.findIndex(
            (el: { uuid: string }) => {
              return el.uuid == candidat.uuid;
            }
          );
          if (indexId !== -1) {
            this.selectedCandidats.splice(indexId, 1);
            candidat.checked = false; // Mettez à jour la propriété checked pour le candidat spécifique
          }
        }
      }
    }
  }

  getListSkills() {
    this.salarieservice.getSkills().subscribe({
      next: (res) => {
        this.skillsList = res.data;
      },
      error: () => {
        this.toastrService.error(serverError);
      },
    });
  }
  createSearchForm(data?: any) {
    let tempCandidateName = '';
    if(this.redirectionCandidateName) {
       tempCandidateName = this.redirectionCandidateName;
      this.redirectionCandidateName = null;
    }
    return this.formBuilder.group({
      candidate_name: [tempCandidateName, data?.candidate_name],
      name: ['', data?.name],
      years_of_experience: ['', data?.years_of_experience],
      experience_range: ['', data?.experience_range],
      contract_type: [[], data?.contract_type],
      desired_salary: ['', data?.desired_salary],
      desired_salary_range: ['', data?.desired_salary_range],
      tjm: ['', data?.tjm],
      tjm_range: ['', data?.tjm_range],
      post_type: [[], data?.post_type],
      skillsOr: [[], data?.skillsOr],
      skillsAnd: [[], data?.skillsAnd],
      country: [[], data?.country],
      city: [[], data?.city],
      availability: [[], data?.availability],
      start_date: ['', data?.start_date],
      end_date: ['', data?.end_date],
      profile_abroad: [null, data?.profile_abroad],
      passeport_talent: [null, data?.passeport_talent],
      state: [null, data?.state],
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
    });
  }
  /* search */
  searchCandidat(pageNumber : number = this.currentPage) {
    this.btnSearchactive = true;
    let valueForm = this.searchForm.value;
    if (valueForm.desired_salary_range != null) {
      valueForm.desired_salary_range = this.convertKToNumber(
        valueForm.desired_salary_range.toString()
      );
    }
    
    let formattedEndDate = this.datePipe.transform(valueForm.end_date, 'yyyy-MM-dd');
    let formattedStartDate = this.datePipe.transform(valueForm.start_date, 'yyyy-MM-dd');
    let data = {
      // sort:this.currentSortDirection,
      // search:search,
      // job_offer_id:this.idoffre,
      name: valueForm.name,
      candidate_name: valueForm.candidate_name,
      search: this.transformSearch(valueForm?.search),
      skillsOr: valueForm.skillsOr,
      skillsAnd: valueForm.skillsAnd,
      years_of_experience: this.searchForm.value.years_of_experience,
      experience_range: this.searchForm.value.experience_range,
      contract_type: this.searchForm.value.contract_type,
      desired_salary: this.searchForm.value.desired_salary,
      desired_salary_range: this.searchForm.value.desired_salary_range,
      availability: valueForm.availability,
      tjm: valueForm.tjm,
      tjm_range: valueForm.tjm_range,
      post_type: valueForm.post_type,
      country: valueForm.country ? valueForm.country : '',
      city: valueForm.city ? valueForm.city : '',
      start_date: formattedStartDate,
      end_date: formattedEndDate,
      profile_abroad: valueForm.profile_abroad,
      passeport_talent: valueForm.passeport_talent,
      state: valueForm.state,
      page: this.currentPage,
      per_page: this.pageSize,
    };
    this.spinner.show();
    this.candidatservice
      .searchcandidatureext(this.idclientConnected, data)
      .subscribe({
        next: (resSearch) => {
            this.listcandidats = resSearch.data.data;
            this.totalCandidateItems = resSearch.data.total;
            this.spinner.hide();
        },
        error: (error) => {
          this.toastrService.error(serverError);
          this.spinner.hide();
        },
      });
  }

    freeSearchCandidat(pageNumber: number = this.currentPage) {
    let valueForm = this.freeSearchForm.value;

    let data = {
      page: this.currentPage,
      per_page: this.pageSize,
      search: this.transformSearch(valueForm?.search),
    }
    this.spinner.show();
    this.candidatservice.searchcandidatureext(this.idclientConnected, data).subscribe({
          next: (resSearch) => {
              const { to, from, total, current_page, data } = resSearch.data;
              this.startSearching = false;
              this.listcandidats= resSearch.data.data;
              this.totalCandidateItems = resSearch.data.total;
              this.spinner.hide();
          },
          error: (error) => {
              this.spinner.hide();
          },
      });
  }
  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = (search || '').replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }

  isSimpleWord(value: string): boolean {
    const simpleWordPattern = /^[a-zA-Z0-9]+(\s[a-zA-Z0-9]+)?$/;
    return simpleWordPattern.test(value);
  }
  onCountryChange(mode: string): void {
    this.searchForm.get('city')?.enable();
    this.countries = this.searchForm.get('country')?.value;
    this.countries = this.countries.map(
      (item: any) => this.paysList.filter((it) => it.name === item)[0]
    );

    this.stateList.length = 0;
    // if (event.length) {
    this.countries.forEach((item: any) => {
      this.stateList.push(State.getStatesOfCountry(item.isoCode));
    });
    this.stateList = this.stateList.flat();
    for (const iterator of this.stateList) {
      iterator.name = iterator.name.replace(' Governorate', '');
    }
    this.stateList = this.stateList.map((item: any) => item.name);
    this.mobilities = this.searchForm.get('city')?.value;
    if (this.mobilities != null && this.mobilities.length > 0) {
      let differentItemsArray1: any[] = [];
      differentItemsArray1 = this.mobilities.filter(
        (item) => !this.stateList.includes(item)
      );
      const differentItemsArray2 = this.mobilities.filter(
        (item) => !differentItemsArray1.includes(item)
      );
      this.searchForm.get('city')?.setValue(differentItemsArray2);
    }
    // }
    if (this.stateList.length == 0) {
      this.stateList = [];
      mode == 'add';
      this.searchForm.get('city')?.setValue(null);
    }
  }
  onMobilityChange(mode: string) {
    this.mobilities = this.searchForm.get('city')?.value;
    let paysLists: any[] = [];
    this.countries = this.searchForm.get('country')?.value;
    this.countries = this.countries.filter(async (item: any) => {
      paysLists.push(this.paysList.filter((it) => it.name === item)[0]);
    });
    let stateListAfter1: any[] = [];
    paysLists.forEach((item) => {
      let stateListAfter: any[] = [];
      stateListAfter = State.getStatesOfCountry(item.isoCode);
      let difference1: any[] = [];
      if (this.countries.length > 0) {
        difference1 = this.findDuplicates(
          this.mobilities,
          stateListAfter.map((item) => item.name)
        );
        if (difference1.length == 0) {
          let index = this.countries.indexOf(item.name);
          if (index !== -1) {
            let new_array = this.countries
              .slice(0, index)
              .concat(this.countries.slice(index + 1));
            this.stateList = this.stateList.filter(
              (item: any) =>
                !stateListAfter.map((item) => item.name).includes(item)
            );

            // this.searchForm.get('country')?.setValue(new_array);
          }
        }
      }
    });
    //  this.stateList=stateListAfter1

    this.mobilities = this.searchForm.get('city')?.value;
    if (this.mobilities.length === 0 || this.stateList.length === 0) {
      this.searchForm.get('city')?.disable();
      mode == 'add';
      this.searchForm.get('country')?.setValue(null);
      mode == 'add';
      this.searchForm.get('city')?.setValue(null);
      this.searchForm.get('country')!.updateValueAndValidity();
      this.searchForm.get('city')!.updateValueAndValidity();
      this.stateList.length = 0;
    }
  }

  findDuplicates(array1: any, array2: any) {
    let occurrences: any[] = [];
    let duplicates: any = [];
    for (let element of array1) {
      occurrences[element] = (occurrences[element] || 0) + 1;
    }
    for (let element of array2) {
      if (occurrences[element] && !duplicates.includes(element)) {
        duplicates.push(element);
      }
    }

    return duplicates;
  }

  openModaladd(template: TemplateRef<any>, data?: any, mode?: string) {
    this.formconsultant.patchValue({
      name: data.name,
      email:data.email,
      first_name:data.first_name,
      last_name:data.last_name,
      linkedin_link:data.linkedin_link,
      post:data.poste,
        })
        this.formconsultant = this.createconsultantForm(data);
        const name = this.formconsultant.get('name');
    if(name && data && data.name) {
      name.setValue(data.name);
    }
        this.formconsultant.get('contract_type')?.setValue(data.contract_type);

    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    setTimeout(() => {
      const input = document.querySelector('#emailField') as HTMLElement;
      input?.focus();
    }, 300);
  }
  reset() {
    this.stateList=[];
    this.currentPage = 0;
    this.freeSearchForm.reset();
    this.freeSearchForm = this.createFreeSearchForm();
    this.searchForm = this.createSearchForm();
    this.getListcandidat();
    this.searchForm.get('start_date')?.valueChanges.subscribe((startDate) => {
      this.minEndDate = startDate ? new Date(startDate) : null;
    });
    this.searchForm.get('end_date')?.valueChanges.subscribe((endDate) =>{
      this.maxStartDate = endDate ? new Date(endDate) : null;
    })
  }

  createapplyForm(data?: any) {
    return this.formBuilder.group({
      letter: [data ? data.letter : ''],
      salary: [data ? data.salary : ''],
      tjm: [data ? data.tjm : ''],
    });
  }

  ngOnDestroy() {
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
  }
  enableFormFields() {
    if (this.formconsultant) {
      this.formconsultant.get('first_name')?.enable();
      this.formconsultant.get('last_name')?.enable();
      this.formconsultant.get('emailProESN')?.enable();
      this.formconsultant.get('linkedin_link')?.enable();
      this.formconsultant.get('desired_workstation')?.enable();
      this.formconsultant.get('cv')?.enable();
    }
  }
  closeModal() {
    this.modalRef!.hide();
    this.applyForm.reset();
  }
  close_modal_add() {
    this.formconsultant.reset();
    this.formconsultant.get('email')?.setValue('');
    this.isButtonDisabled = false;

    this.selectedconsultant = '';
    this.cdRef.detectChanges();
    let btnClose = document.getElementById('ModalClose_add_consultant');
    if (btnClose) {
      btnClose.click();
      this.formconsultant.reset();
      this.cvName = '';
      this.errorMessage = '';
      this.selectedconsultant = '';
      this.cdRef.detectChanges();
    }

    this.enableFormFields();
    this.isButtonDisabled = false;
    this.errorMessage = '';
    this.selectedconsultant = '';
    this.showResetButtons = false;
    if (this.modalRef && typeof this.modalRef.hide === 'function') {
      this.modalRef.hide();
    }
    this.iscv=false
  }
  // @TOFIX : duplicated
  /**
   * Returns a string list of contract types for tooltip display based on contract type codes.
   * @param contractTypes - An array of contract type codes.
   * @returns A string listing the contract type names.
   */
  getContractTypeList(contractTypes: number[]): string {
    const contractMap: { [key: string]: string } = {
        '1': 'Alternance',
        '2': 'Autres type de contrat',
        '3': 'CDD',
        '4': 'CDI',
        '5': 'Freelance',
        '6': 'Portage salarial',
        '7': 'Stage'
    };

    return contractTypes.map(type => contractMap[type.toString()] || '').join(', ');
  }

  downloadResponseFile(type: string, candidate : any) {
    let fileUrl = `${this.url}`
    if(type === this.companyTypeEnum.ESN){
      fileUrl = fileUrl.concat(`/TestJob/GetFileESNTest/${candidate?.file_test_esn}`)
    } else{
      fileUrl = fileUrl.concat(`/ResponseCandidate/GetFile/${candidate?.file_test}`)
    }

    this.showGlobalSpinner();
    this.candidatservice.downloadFile(fileUrl).subscribe(
      (data) => {
        const blob = new Blob([data], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${candidate.candidat_first_name}_${candidate.candidat_last_name}-Réponses_Test_QCM_WEGESTU.pdf`
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        this.hideGlobalSpinner();
      },
      () => {
          this.hideGlobalSpinner();
      }
    );
  }

  closeModalScore() {
    let btnClose = document.getElementById('ModalCloseScore');
    if (btnClose) {
      btnClose.click();
    }
  }

  showModal = false;
  
  openModals() {
    this.showModal = true;
  }

  closeModals() {
    this.showModal = false;
  }
  openModalScore(candidate : any){    
    this.jobofferservice.getDetailScore(candidate?.uuid, candidate?.candidat_id).subscribe({
      next: (res: any) => {
        this.candidateScoreDetail = res?.data
      },
      error: (error) => {
      },
    });
  }

  addAsConsultantNavigation(consultant: any) {
    this.router.navigate(['/consultants/ajout-consultant/'], {
    state: {
      data : {type: '1', email: consultant?.candidat_email}
      },
    });
  }
}
